
export class Function extends globalThis.Function
{
}


export namespace Function
{
    /**
     * Invokes a function ansynchronously and returns a promise to be fulfilled once the function completes with the result.
     * @param $function The function to invoke asynchronously.
     * @returns The promise with asynchronous function invocation result.
     */
    export function runAsync<T>($function: (...args: any) => T): Promise<T>;
    export function runAsync<T>($function: (...args: any) => T, delay: number): Promise<T>;
    export function runAsync<T>($function: (...args: any) => T, delay?: number): Promise<T>
    {
        return (
            new Promise<T>(
                onComplete =>
                    setTimeout(
                        () => onComplete($function()),
                        delay ?? 0
                    )
            )
        );
    }

    // /**
    //  * Binds the given function to 'thisArg' and preserves its typing 
    //  * through the binding process (which typically returns the 'any' type).
    //  * 
    //  * @param thisArg the bind target for 'functionToBind'
    //  * @param functionToBind the function to be bound
    //  * @returns 'functionToBind' bound to 'targetThis' with the typing of 'functionToBind'
    //  */
    // export function bind<T extends Function>(functionToBind: T, thisArg: any): T
    // {
    //     return functionToBind.bind(thisArg);
    // }
}


declare global
{
    interface Function
    {
        bind<T extends (...args: any) => any>(this: T, thisArg: any, ...argArray: any): T;
    }
}
